<template>
    <div id="orders-view">
        <div v-for="order in ordersUser" :key="order.id">
            <div class="order-wrapper" v-if="resort.id === order.resort_id && order.status.id === 4" @click="loadOrder(order)">
                <div>
                    <span class="product">
                        {{translate(order.details[0].product, 'name')}}
                    </span>
                    <span class="date">
                        {{order.details[0].date | shortDate}}
                    </span>
                    <span class="order">
                        {{ $t("myorders.order") + ": " + order.reference }}
                    </span>
                </div>
                <div>
                    <img class="icon inline-block" :src="`/img/icons/icon-${icon(order.details.length)}.svg`">
                    <span class="participants">{{order.details.length}}</span>
                    <img class="icon inline-block mb-px" src="/img/icons/icon-grey-arrow-right.svg">
                </div>
            </div>
        </div>
        <div class="no-orders text-center pt-6 text-lg" v-if="noOrders">
            <span>{{$t("myorders.no_orders")}}</span>
            <img class="image-not-found" src="@/assets/img/img-placeholder-horizontal.png">
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { translate }  from '@/helpers/translationsHelpers.js';

export default {
    name: "Orders",
    computed: {
        ...mapGetters('order', ['ordersUser']),
        ...mapGetters('resort', ['resort']),
        noOrders: function(){
            return !(this.ordersUser.length > 0 && this.ordersUser.some(order => 
                order.resort_id === this.resort.id && (order.status.id === 1 || order.status.id === 4 || order.status.id === 7)))
        }
    },
    methods: {
        ...mapActions("order", ["setOrderDetails"]),
        translate(object, field) {
            return translate(object, field)
        },
        icon(people) {
            return people == 1 ? 'person' : 'people'
        },
        loadOrder(order) {
            this.setOrderDetails(order)
            this.$router.push({ name: 'Order details' })
        }
    }
}
</script>

<style scoped>
    .order-wrapper {
        @apply w-full h-24 pl-6 pr-4 flex justify-between items-center bg-white border-b-1 border-grey-border cursor-pointer;
    }

    .product {
        @apply text-xl text-black text-left block;
    }

    .date {
        @apply text-1xs text-grey-text text-left block;
    }

    .order {
        @apply text-1xs text-grey-text text-left block;
    }

    .participants {
        @apply text-sm text-grey-text ml-2 mr-4;
    }

    .no-orders {
        background: url('../assets/img/img-placeholder-vertical.png') no-repeat center center fixed;
        background-size: cover;
        min-height: calc(100vh - 48px);
    }

    .image-not-found {
        @apply hidden;
    }

    @screen lg {
        .no-orders {
            background-image: none !important;
            @apply bg-grey-bg;
        }

        .no-orders span {
            @apply p-0 text-1xl;
        }

        .image-not-found {
            @apply block;
        }
    }
</style>